<template>
    <v-row no-gutters class="full-size">
      <div id="panel" v-if="status === 'ARRAY_COMPLETED' || status === 'ARRAY_ERROR' || status === 'ARRAY_SKIP'">
        <v-row justify="center">
          <v-col cols="sm-2">   
              <v-card-text>
                アレイ抽出調整
                <v-slider 
                  class="pt-1"
                  ref="slider"
                  v-model="blur_size"
                  :min="5"
                  :max="65"
                  step="10"
                  @input="changeBlurSize(blur_size)"
                >
                </v-slider>
                <div ref="test" style="width:100%; position: relative; top: -31px; z-index: -50;">
                  <div class="slider-tick" v-for="(item, i) in selected_blursizes" :key="i" :style="{left : 'calc('+((item-5)/60)*100+'% - 9px)'}">
                  </div>
                </div>
              </v-card-text>
          </v-col>
          <v-col cols="auto">
            <v-row>
              <v-tooltip bottom>
                <template v-slot:activator="{on, attrs}">
                  <div id="point-4" @click="addRectangleAnotation(h2pAnotation.mode === 'addPolygon' ? 'none' : 'addPolygon', 'polygon')" v-bind="attrs" v-on="on" :style="{
                  backgroundColor : type_point=='polygon' ? '#1976d2 !important' : '#3e3c3c',
                  }">
                    <div align-self="center" class="point-icon">
                      <v-icon color="white" style="font-size: 20px;">
                        mdi-shape-polygon-plus
                      </v-icon>
                    </div>
                    <div align-self="center" class="point-label">
                      <span>４ポイント</span>
                    </div>
                  </div>
                </template>
                <h5>{{ "４ポイントでアレイを追加します。" }}</h5>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on, attrs}">
                  <div id="point-2" @click="addRectangleAnotation(h2pAnotation.mode === 'addBox' ? 'none' : 'addBox', 'box')" v-bind="attrs" v-on="on"  :style="{
                  backgroundColor : type_point=='box' ? '#1976d2 !important' : '#3e3c3c',
                  }">
                    <div cols="auto" align-self="center" class="point-icon">
                      <v-icon color="white" style="font-size: 20px;">
                        mdi-shape-rectangle-plus
                      </v-icon>
                    </div>
                    <div align-self="center" class="point-label">
                      <span>2ポイント</span>
                    </div>
                  </div>
                </template>
                <h5>{{ "２ポイントでアレイを追加します。" }}</h5>
              </v-tooltip>
            </v-row>
          </v-col>
          <v-col cols="auto">
            <v-btn
            block
            color="default"
            :disabled="checkSelect === false"
            @click="deleteRectangleAnotation(h2pAnotation.mode === 'delete' ? 'none' : 'delete')"
            >
              <v-icon dark left>mdi-minus-circle</v-icon>
              削除
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
            color="default"
            @click="showUploadLasFileDialog"
            >点群アップロード
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
            color="primary"
            @click="showCreateH2pDialog"
            >h2pを作成</v-btn>
          </v-col>
        </v-row>
      </div>
      <div id="panel" v-if="status === 'NEW' || status === 'ARRAY_QUEUEING' || status === 'ARRAY_PROCESSING'">
        <v-row justify="center">
          <v-col cols="auto">
            <v-chip
              v-if="status === 'NEW'"
              color="default"
              small
            >
              {{ getStatusText(status) }}
            </v-chip>
            <v-chip
              v-if="status === 'ARRAY_QUEUEING'"
              color="secondary"
              small
            >
              {{ getStatusText(status) }}
            </v-chip>
            <v-chip
              v-if="status === 'ARRAY_PROCESSING'"
              color="primary"
              small
            >
              {{ getStatusText(status) }}
            </v-chip>
          </v-col>
          <v-col cols="auto">
            <v-btn
            block
            :disabled="status === 'ARRAY_QUEUEING' || status === 'ARRAY_PROCESSING'"
            @click="getArrayPosition(arrayPositionId, true)"
            >
              <v-icon left>mdi-map-marker-plus</v-icon>
              アレイ位置を抽出
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
            block
            :disabled="status === 'ARRAY_QUEUEING' || status === 'ARRAY_PROCESSING'"
            @click="getArrayPosition(arrayPositionId, false)"
            >
              <v-icon dark left>mdi-minus-circle</v-icon>
              アレイ位置抽出をスキップ
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div id="mapArrayPosition" ref="mapArrayPosition"></div>
      <h2p-create-file-dialog
      v-model="createH2pDialog"
      :las_file="las_file"
      :array_position_id="arrayPositionId"
      :blur_size="blur_size"
      ></h2p-create-file-dialog>
      <h2p-upload-lasfile-dialog
      v-model="uploadLasFileDialog"
      :folder_id="folderId"
      >
      </h2p-upload-lasfile-dialog>
      <v-snackbar
        v-model="showSnackbar"
      >
        {{ snackbarMessage }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="showSnackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-overlay :value="overlay"></v-overlay>
    </v-row>
</template>
<script>
import {store} from "@/store";
import 'ol/ol.css'
import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import OSM from 'ol/source/OSM'
import XYZ from "ol/source/XYZ";
import RectangleAnnotation from "@/utils/h2pAnotation";
import H2pCreateFileDialog from '../dialog/H2pCreateFileDialog.vue';
import H2pUploadLasFileDialog from '../dialog/H2pUploadLasFileDialog.vue';

export default {
  name: "ViewPosition",
  components: {
    'h2p-create-file-dialog': H2pCreateFileDialog,
    'h2p-upload-lasfile-dialog': H2pUploadLasFileDialog,
  },
  data() {
    return {
        overlay: false,
        arrayPositionId: this.$route.params.arrayPositionId, 
        folderId: this.$route.params.folderId,
        mapview: null,
        mapInitialPosition: {
          bound_1_lng: 0,
          bound_1_lat: 0,
          bound_2_lng: 0,
          bound_2_lat: 0,
        },
        layers: null,
        coordinate: [],
        h2pAnotation: new RectangleAnnotation(),
        draw: null,
        annotationAddInfo: null,
        panelInfo: {
          Id: null,
          points: [],

        },
        listAddPoint: [],
        annotationSelectedInfo: [],
        idAnotation: [],
        idAdd: null,
        checkSelect: false,
        //h2p create
        createH2pDialog: false,
        las_file: [],
        showSnackbar: false,
        snackbarMessage: null,
        max_zoom: null,
        blur_sizes : [
          5, 15, 25, 35, 45, 55, 65
        ],
        blur_size: null,
        list_array_coordinate: {
          "5": [],
          "15": [],
          "25": [],
          "35": [],
          "45": [],
          "55": [],
          "65": []
        },
        type_point : null,
        selected_blursizes: [],
        copiedAnnotation: null,
        currentPosition: null,
        distancePolygon: [],
      
        status: null,
        uploadLasFileDialog: false,
    };
  },
  methods: {
    initMap() {
      this.resetLayers();
      this.axios
        .get("/api/h2p/array-position/" + this.arrayPositionId)
        .then((response) => {
          this.status = response.data.array_position.status;
          if(response.data.array_position.blur_size == null){
            this.blur_size = 25;
          }else{
            this.blur_size = response.data.array_position.blur_size;
          }
          const blursizes  = response.data.array_position.selected_blursizes;
          this.selected_blursizes = JSON.parse(blursizes)["list"];
          this.setLayer(this.layers,response.data.array_position);
          this.list_array_coordinate = response.data.array_coordinate;
          this.setRectangleAnotation( this.list_array_coordinate[this.blur_size]);
          this.max_zoom = response.data.array_position.max_zoom;
          this.mapview = new Map ({
              target: this.$refs.mapArrayPosition,
              layers: [
                new TileLayer({
                  zIndex: 0,
                  title: "ベースマップ",
                  opacity: 100,
                  visible: true,
                  source: new OSM(),
                }),
                new TileLayer({
                  zIndex: 1,
                  opacity: this.layers[1].transparency,
                  visible: this.layers[1].visible,
                  extent: [
                    this.layers[1].bound1Lng,
                    this.layers[1].bound1Lat,
                    this.layers[1].bound2Lng,
                    this.layers[1].bound2Lat,
                  ],
                  source: new XYZ({
                    attributions: "",
                    url: this.layers[1].mapUrl,
                    tileSize: [256, 256],
                    minZoom:17,
                    maxZoom: this.max_zoom
                  }),
                }),
                this.h2pAnotation.layer,
              ],
              view: new View({
                minZoom: 17,
                maxZoom: 23,
                zoom: 17,
                center: [
                  (this.mapInitialPosition.bound_1_lng +
                    this.mapInitialPosition.bound_2_lng) /
                  2,
                  (this.mapInitialPosition.bound_1_lat +
                      this.mapInitialPosition.bound_2_lat) /
                  2,
                ],
              })
          });

          const mapExtent = [
            this.mapInitialPosition.bound_1_lng - 1000,
            this.mapInitialPosition.bound_1_lat - 1000,
            this.mapInitialPosition.bound_2_lng + 1000,
            this.mapInitialPosition.bound_2_lat + 1000,
          ];

          const screenExtent = this.mapview.getView().calculateExtent();
          mapExtent.forEach((position, index) => {
            if (position < screenExtent[index] && index >= 2) {
              mapExtent[index] = screenExtent[index];
            }
            if (position > screenExtent[index] && index <= 1) {
              mapExtent[index] = screenExtent[index];
            }
          });

          this.mapview.setView(new View({
            minZoom: 17,
            maxZoom: 23,
            zoom: 17,
            center: [
              (this.mapInitialPosition.bound_1_lng +
                  this.mapInitialPosition.bound_2_lng) /
              2,
              (this.mapInitialPosition.bound_1_lat +
                  this.mapInitialPosition.bound_2_lat) /
              2,
            ],
            extent: mapExtent,
          }));

          this.mapview.getView().setZoom(21);
          this.mapview
            .getView()
            .fit([
              this.mapInitialPosition.bound_1_lng,
              this.mapInitialPosition.bound_1_lat,
              this.mapInitialPosition.bound_2_lng,
              this.mapInitialPosition.bound_2_lat,
            ]);

          this.mapview.on("pointermove", (evt) =>{
            const pixel = this.mapview.getEventPixel(evt.originalEvent);
            const hit = this.mapview.hasFeatureAtPixel(pixel);
            this.mapview.getTarget().style.cursor = hit ? 'pointer' : '';
            this.currentPosition = evt.coordinate;
          });

          this.mapview.on("click", (evt) =>{
            this.listAddPoint.push(evt.coordinate);
            if (this.h2pAnotation.mode === "addPolygon") {
              if(this.listAddPoint.length == 4) {
                this.panelInfo.points = [];
                this.listAddPoint.forEach((element, key) => {
                  this.panelInfo.Id = new Date().getTime();
                  const info = {
                      "OBJECTID": key,
                      "ORIG_OID": "",
                      "POINT_Y": element[1],
                      "POINT_X": element[0],
                      "POINT_Z": "0.0"
                  }
                  this.panelInfo.points.push(info);
                });
                this.annotationAddInfo = {
                  type: "Polygon",
                  coordinates: this.panelInfo,
                  id: this.panelInfo.Id,
                };
                this.overlay = true;
                this.saveAnotation();  
              }
            }else if(this.h2pAnotation.mode === "addBox") {
              if(this.listAddPoint.length == 2) {
                this.panelInfo.points = [];
                this.panelInfo.Id = new Date().getTime();
                const info1 = {
                  "OBJECTID": 0,
                  "ORIG_OID": "",
                  "POINT_Y": this.listAddPoint[0][1],
                  "POINT_X": this.listAddPoint[0][0],
                  "POINT_Z": "0.0"
                };
                const info2 = {
                  "OBJECTID": 1,
                  "ORIG_OID": "",
                  "POINT_Y": this.listAddPoint[1][1],
                  "POINT_X": this.listAddPoint[0][0],
                  "POINT_Z": "0.0"
                };
                const info3 = {
                  "OBJECTID": 2,
                  "ORIG_OID": "",
                  "POINT_Y": this.listAddPoint[1][1],
                  "POINT_X": this.listAddPoint[1][0],
                  "POINT_Z": "0.0"
                };
                const info4 = {
                  "OBJECTID": 3,
                  "ORIG_OID": "",
                  "POINT_Y": this.listAddPoint[0][1],
                  "POINT_X": this.listAddPoint[1][0],
                  "POINT_Z": "0.0"
                };
                this.panelInfo.points.push(info1,info2,info3,info4);   
                this.annotationAddInfo = {
                  type: "Polygon",
                  coordinates: this.panelInfo,
                  id: this.panelInfo.Id,
                };
                this.overlay = true;
                this.saveAnotation();
              }
            }else if (this.h2pAnotation.mode == "copy") {
              this.saveCopyPolygon();
            }else {
              const pixel = this.mapview.getEventPixel(evt.originalEvent);
              const hit = this.mapview.hasFeatureAtPixel(pixel);
              if(hit) {
                this.checkSelect = true;
                this.mapview.forEachFeatureAtPixel(evt.pixel, (feature) => {
                  if(feature ) {
                    feature.setStyle(
                      this.h2pAnotation.modifyStyleFunction,
                    );
                    this.annotationSelectedInfo.push(feature);
                    this.h2pAnotation.setModifyTranslate(this.mapview, feature, (info)=>this.editRectangleAnotation(info));
                  }
                });
              }else{
                this.checkSelect = false;
                this.annotationSelectedInfo.forEach(element => {
                  element.setStyle(this.h2pAnotation.featureStyleFunction);
                });
                this.annotationSelectedInfo = [];
                this.mapview.removeInteraction(this.h2pAnotation.translate);
                this.mapview.removeInteraction(this.h2pAnotation.modify);
              }
            }
            
          });
        })
        .catch(() => {
          store.showErrorDialog("該当データがありません。");
        });
    },
    onChangeTransparency(layer) {
      this.mapview.getLayers().getArray()[layer.index].setOpacity(layer.transparency / 100);
    },
    setMapLayerLocation(layer, ddMap) {
      layer.mapUrl = ddMap.path;
      layer.bound1Lng = ddMap.bound_1_lng;
      layer.bound1Lat = ddMap.bound_1_lat;
      layer.bound2Lng = ddMap.bound_2_lng;
      layer.bound2Lat = ddMap.bound_2_lat;
      layer.visible = true; 
    },
    setLayer(layer, ddMapPlan) {
      this.setMapLayerLocation(layer[1], ddMapPlan);
      this.mapInitialPosition = JSON.parse(JSON.stringify(ddMapPlan));
    },
    resetLayers() {
      this.layers = [
          {
            visible: true,
            index: 0,
            text: "ベースマップ",
            value: "basic",
            transparency: 100,
          },
          {
            visible: true,
            index: 1,
            text: "アレイ位置編集",
            value: "arrayposition",
            transparency: 100,
            mapUrl: "",
            bound1Lng: 0,
            bound1Lat: 0,
            bound2Lng: 0,
            bound2Lat: 0,
          },
          {
            visible: true,
            transparency: 100,
            index: 2,
            text: "矩形アノテーション",
            value: "rectangle_anotation"
          }
      ]
    },

    setRectangleAnotation(coordinates) {
      this.h2pAnotation.drawPolygonOnMap(coordinates);
    },

    addRectangleAnotation(mode, type_point) {
      this.annotationAddInfo = {};
      this.listAddPoint = [];
      this.h2pAnotation.mode = mode;
      if (this.h2pAnotation.mode === "none") {
        this.mapview.removeInteraction(this.h2pAnotation.draw);
        this.type_point = null;
      } else {
        this.type_point = type_point;
        this.h2pAnotation.changeTypePoint(this.mapview, type_point);
      } 
    },

    deleteRectangleAnotation(mode) {
      this.h2pAnotation.mode = mode;
      if(this.h2pAnotation.mode === "delete") {
        this.idAnotation = [];
        this.annotationSelectedInfo.forEach(element => {
          this.idAnotation.push(element.getId());
        });

        const confirmDialog = {
          title: "削除確認",
          content: 'このアノテーションを削除します。よろしいですか。',
          onAgree: () => {
            this.deleteAnotation();
          },
          onDisagree: null,
        };
        store.showConfirmDialog(confirmDialog);
      }
    },

    editRectangleAnotation(info) {
      const anotationPoint = info.getGeometry().getCoordinates()[0];
      const id = info.getId();
      const editInfo = [];
      anotationPoint.forEach((element,key) => {
        const info = {
            "OBJECTID": key,
            // "Id": id,
            "ORIG_OID": "",
            "POINT_Y": element[1],
            "POINT_X": element[0],
            "POINT_Z": "0.0"
        }
        editInfo.push(info);
      });
      editInfo.splice(4, 1);
      this.overlay = true;
      this.axios
      .put("/api/h2p/array-position/" + this.arrayPositionId, {data : {'info': editInfo, 'id': id, 'blur_size': this.blur_size}})
      .then((response) => {
        if(response.data.status == true){
          this.h2pAnotation.mode = null;
          this.h2pAnotation.drawPolygonOnMap(response.data.array_coordinate);
          this.mapview.removeInteraction(this.h2pAnotation.translate);
          this.mapview.removeInteraction(this.h2pAnotation.modify);
          this.checkSelect = false;
          this.annotationSelectedInfo = [];
          this.selected_blursizes = response.data.selected_blursizes;
        }
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
      })
      .finally(() => {
        this.overlay = false;
      });
        
    },

    // h2p create
    showCreateH2pDialog() {
      // const folder_id = item["folder_id"];
      this.axios.post("/api/h2p/get-las", {'folder_id': this.folderId}).then((response) => {
        this.las = response.data;
        this.las.forEach(element => {
          const data = [];
          data['text'] = element.filename;
          data['value'] = element.path;
          this.las_file.push(data);
        });
        this.createH2pDialog = true;
      });
    },

    showSnackbarMessage(message) {
      this.snackbarMessage = message;
      this.showSnackbar = true;
    },

    showBreadCrumb() {
      this.axios.get("/api/h2p/main-plant/" + this.folderId).then((response) => {
        const data = response.data[0];
        const breadcrumbs = [
          {
            text: "発電所一覧",
            disabled: false,
            exact: true,
            to: "/h2p",
          },
          {
            text: data.name,
            disabled: false,
            exact: true,
            to: "/h2p/" + data.id + "/data",
          },
        ];
        store.updateH2pMapViewBreadcrumbs(breadcrumbs);
      });
    },
    changeBlurSize(blur_size){
      this.blur_size = blur_size;
      this.axios
        .get("/api/h2p/array-position/" + this.arrayPositionId)
        .then((response) => {
          this.list_array_coordinate = response.data.array_coordinate;
          this.setRectangleAnotation(this.list_array_coordinate[blur_size]);
        });
    },
    saveAnotation(){
      this.axios
      .post("/api/h2p/array-position/", {data : {'info': this.panelInfo, 'id': this.arrayPositionId, 'blur_size': this.blur_size}})
      .then((response) => {
        if(response.data.status == true){
          this.h2pAnotation.addNewFeature(this.annotationAddInfo);
          this.h2pAnotation.mode = null;
          this.listAddPoint = [];
          this.selected_blursizes = response.data.selected_blursizes;
          this.mapview.removeInteraction(this.h2pAnotation.draw);
          this.type_point = null;
          this.showSnackbarMessage("矩形アノテーションを追加しまた。");
        }
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
        
      })
      .finally(() => {
        this.overlay = false;
      }); 
    },
    addCopyEventListener(){
      document.addEventListener('keydown', this.handleKeyPressed);
    },
    removeCopyEventListener(){
      document.removeEventListener('keydown', this.handleKeyPressed);
    },
    handleKeyPressed(evt){
      if ( evt.ctrlKey && evt.code === "KeyC" && this.annotationSelectedInfo.length >= 1){
        this.h2pAnotation.mode = 'copy';
        this.copiedAnnotation = this.annotationSelectedInfo[this.annotationSelectedInfo.length - 1];
        const coordinates = this.copiedAnnotation.getGeometry().getCoordinates()[0];

        const maxPointX = Math.max(coordinates[0][1], coordinates[1][1], coordinates[2][1], coordinates[3][1]);
        const minPointX = Math.min(coordinates[0][1], coordinates[1][1], coordinates[2][1], coordinates[3][1]);
        const centerPointX = (maxPointX + minPointX)/2;

        const maxPointY = Math.max(coordinates[0][0], coordinates[1][0], coordinates[2][0], coordinates[3][0]);
        const minPointY = Math.min(coordinates[0][0], coordinates[1][0], coordinates[2][0], coordinates[3][0]);
        const centerPointY = (maxPointY + minPointY)/2;

        const distanceP1 = [coordinates[0][0] - centerPointY, coordinates[0][1] - centerPointX];
        const distanceP2 = [coordinates[1][0] - centerPointY, coordinates[1][1] - centerPointX];
        const distanceP3 = [coordinates[2][0] - centerPointY, coordinates[2][1] - centerPointX];
        const distanceP4 = [coordinates[3][0] - centerPointY, coordinates[3][1] - centerPointX];
        this.distancePolygon.push(distanceP1, distanceP2, distanceP3, distanceP4);

        this.h2pAnotation.copiedCoordinate.push(distanceP1, distanceP2, distanceP3, distanceP4);
        this.mapview.addInteraction(this.h2pAnotation.copyDraw);
        this.showSnackbarMessage('コピーしました。クリックでペーストされます。[Esc]でコピーモードが解除されます。');
        
      } else if (evt.code ==="Escape") {
        this.mapview.removeInteraction(this.h2pAnotation.copyDraw);
        this.h2pAnotation.mode = null;
        this.h2pAnotation.copiedCoordinate = [];
        this.distancePolygon = [];
        this.checkSelect = false;
        this.annotationSelectedInfo.forEach(element => {
          element.setStyle(this.h2pAnotation.featureStyleFunction);
        });
        this.annotationSelectedInfo = [];
        this.mapview.removeInteraction(this.h2pAnotation.translate);
        this.mapview.removeInteraction(this.h2pAnotation.modify);
      } else if ( (evt.code === "Backspace" || evt.code === "Delete") && this.annotationSelectedInfo.length >= 1){
        this.deleteRectangleAnotation('delete');
        
      } else if (this.h2pAnotation.mode === "delete" && evt.code === "Enter") {
        this.deleteAnotation();
        store.resetConfirmDialog();
      }
    },
    saveCopyPolygon() {
      this.panelInfo.points = [];
      this.panelInfo.Id = new Date().getTime();
      const info1 = {
        "OBJECTID": 0,
        "ORIG_OID": "",
        "POINT_X": this.currentPosition[0] + this.distancePolygon[0][0],
        "POINT_Y": this.currentPosition[1] + this.distancePolygon[0][1],
        "POINT_Z": "0.0"
      };
      const info2 = {
        "OBJECTID": 1,
        "ORIG_OID": "",
        "POINT_X": this.currentPosition[0] + this.distancePolygon[1][0],
        "POINT_Y": this.currentPosition[1] + this.distancePolygon[1][1],
        "POINT_Z": "0.0"
      };
      const info3 = {
        "OBJECTID": 2,
        "ORIG_OID": "",
        "POINT_X": this.currentPosition[0] + this.distancePolygon[2][0],
        "POINT_Y": this.currentPosition[1] + this.distancePolygon[2][1],
        "POINT_Z": "0.0"
      };
      const info4 = {
        "OBJECTID": 3,
        "ORIG_OID": "",
        "POINT_X": this.currentPosition[0] + this.distancePolygon[3][0],
        "POINT_Y": this.currentPosition[1] + this.distancePolygon[3][1],
        "POINT_Z": "0.0"
      };
      this.panelInfo.points.push(info1,info2,info3,info4);   
      this.annotationAddInfo = {
        type: "Polygon",
        coordinates: this.panelInfo,
        id: this.panelInfo.Id,
      };
      this.overlay = true;
      this.axios
      .post("/api/h2p/array-position/", {data : {'info': this.panelInfo, 'id': this.arrayPositionId, 'blur_size': this.blur_size}})
      .then((response) => {
        if(response.data.status == true){
          this.h2pAnotation.addNewFeature(this.annotationAddInfo);
          this.listAddPoint = [];
          this.selected_blursizes = response.data.selected_blursizes;
          this.showSnackbarMessage("矩形アノテーションを追加しまた。");
          this.mapview.removeInteraction(this.h2pAnotation.translate);
          this.mapview.removeInteraction(this.h2pAnotation.modify);
        }
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
        
      })
      .finally(() => {
        this.overlay = false;
      }); 
      
    },

    getStatusText(type) {
      const statusTypes = [
        { text: "未抽出", value: "NEW" },
        { text: "抽出待ち", value: "ARRAY_QUEUEING"},
        { text: "抽出中", value: "ARRAY_PROCESSING" },
        { text: "抽出完了", value: "ARRAY_COMPLETED"},
        { text: "抽出スキップ", value: "ARRAY_SKIP"},
        { text: "エラー", value: "ARRAY_ERROR"},
      ];
      return statusTypes.find(x => x.value == type).text;
    },

    getArrayPosition(id, getAI) {
      this.axios
        .post(
          "/api/h2p/update-status", {'id': id, 'getAI': getAI,}
        )
        .then(() => {
          if (getAI == true) {
            this.status = "ARRAY_QUEUEING";
          } else {
            this.status = "ARRAY_COMPLETED";
          }
        })
        .catch(() => {
          store.showErrorDialog("エラーが発生しました。再度試してください。");
        });
    },
    showUploadLasFileDialog() {
      this.uploadLasFileDialog = true;
    },
    deleteAnotation() {
      this.overlay = true;
        this.axios
          .delete("/api/h2p/array-position/" + this.arrayPositionId, {data : {'idAnotation': this.idAnotation, 'blur_size': this.blur_size}})
          .then((response) => {
            if(response.data.status === true){
              this.h2pAnotation.removeFeature(this.annotationSelectedInfo);
              this.h2pAnotation.mode = null;
              this.annotationSelectedInfo = [];
              this.checkSelect = false;
              this.selected_blursizes = response.data.selected_blursizes;
              this.mapview.getInteractions().pop();
              this.showSnackbarMessage("削除しました。");
            }
            
          })
          .catch(() => {
            this.h2pAnotation.layer.setStyle(this.h2pAnotation.featureStyleFunction);
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          })
          .finally(() => {
            this.overlay = false;
          });
    }
  },

  created() {
    this.showBreadCrumb();
    this.addCopyEventListener();
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy() {
    this.removeCopyEventListener();
  }
};
</script>

<style>
.full-size {
  width: 100%;
  height: 100%;
}

#mapArrayPosition {
  width: 100%;
  height: 100%;
}
#panel {
  position: absolute;
  width: 100%;
  z-index: 1;
  border-radius: 4px;
  color: white;
}
#panel .row .col{
  background-color: rgb(19 13 13 / 40%);
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #f5f5f5 !important;
}
.blur_size .v-text-field.v-text-field--solo .v-input__control{
  min-height: 36px !important;
}
.blur_size {
  padding-bottom: 0px;
  width: 130px;
}
.v-slider--horizontal {
  min-height: 0px !important;
  /* max-height: 37px; */
  color: #ffff;
}
.v-input--selection-controls {
  margin-top: 5px;
  padding-top: 4px;
}
.v-application .pt-1 {
  position:relative;
}
#point-4 {
  width: auto;
  z-index: 90;
  border-radius: 4px;
  padding: 0px 4px;
  height: 38px;
}
#point-4:hover {
  cursor: pointer;
}
#point-2 {
  width: auto;
  z-index: 90;
  border-radius: 4px;
  margin-left: 10px;
  padding: 0px 4px;
  height: 38px;
}
#point-2:hover {
  cursor: pointer;
}
.point-icon {
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 15px;
  background-color: transparent;
  font-size:10px
}
.point-label {
  padding-top: 0;
  padding-bottom: 0;
  background-color: transparent;
  font-size:12px;
}
.slider-tick {
  background-color: rgb(129 125 125);
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
}
.v-slider--horizontal {
  min-height: 32px;
  margin-left: 0px; 
  margin-right: 0px;
}
</style>
